module.exports = "<p>\r\n  rider works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/riders/rider.component.html
// module id = 2528
// module chunks = 66